import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { pagesState, mySession, requestOTPAsync, clearAction, ValidateOTPAsync, resendOTPAsync, triggerDisableBtn, ChangeCountdownNumber, GetPriceRuleAsync, formData, myLibs, checkOutCurCart, ValidateEmailAsync } from './controller';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import useDynamicRefs from 'use-dynamic-refs';

export function SchoolSummary() {

    const dispatch = useDispatch();
    const pages_state = useSelector(pagesState);
    const form_Data = useSelector(formData);
    const my_Libs = useSelector(myLibs);
    const [getRef, setRef] = useDynamicRefs();

    var [alllowProceed, setalllowProceed] = useState(false);
    var toggleProceedtoForm = () => setalllowProceed(!alllowProceed);

    var [showVdalidateOTP, setshowVdalidateOTP] = useState(false);
    var handleshowVdalidateOTPModal = () => {
        setshowVdalidateOTP(!showVdalidateOTP)
    };

    const maskValue = (input) => {
        var maskid = "";
        var myemailId = input;
        var prefix = myemailId.substring(0, myemailId.lastIndexOf("@"));
        var postfix = myemailId.substring(myemailId.lastIndexOf("@"));

        for (var i = 0; i < prefix.length; i++) {
            if (i === 0 || i === prefix.length - 1) {
                maskid = maskid + prefix[i].toString();
            } else {
                maskid = maskid + "*";
            }
        }
        maskid = maskid + postfix;
        return maskid;
    }

    const sendOtp = (item) => {
        var data = {
            "Email": form_Data.RequestorEmail
        }
        dispatch(ValidateEmailAsync(data));
    }

    const resendOTP = () => {
        var countdown = 60;
        dispatch(triggerDisableBtn(true));
        // dispatch(ChangeCountdownNumber(countdown));
        var data = {
            "Email": form_Data.RequestorEmail
        }
        dispatch(ValidateEmailAsync(data));

        var startResendOTP = setInterval(() => {
            countdown = countdown - 1;
            dispatch(ChangeCountdownNumber(countdown));
            if (countdown === 0) {
                clearInterval(startResendOTP);
                dispatch(triggerDisableBtn(false));
            }
        }, 1000);
    }

    const validateOTP = (e) => {
        e.preventDefault();
        var data = {
            "key": pages_state ? pages_state.OTPKey : '',
            "otp": getRef('otp').current.value
        }

        dispatch(ValidateOTPAsync(data));
    }

    useEffect(() => {
        dispatch(GetPriceRuleAsync());
        if (!sessionStorage.getItem('sfs')) {
            window.location.href = "./";
        }
    }, []);

    return (
        <section id="MarriageDisclaimer">
            {(pages_state.status !== 'idle' || pages_state.status === 'rejected') && <div className="position-fixed loadingScreen d-flex justify-content-center align-items-center"><img src="./images/loading.gif" className="icons-loading" alt="" /></div>}
            <div className="container-fluid mt-3 disclaimer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                            <img src="./images/icn-OnTopSchool.png" alt="" />
                                <h2 className="pageTitle mt-2">School Record</h2>
                                <p className="theme-color">Checkout Summary</p>
                                <div className="step">
                                    <div className="breadcrumbs">
                                        <ul className="steps d-flex justify-content-center align-items-center">
                                            <li><img src="./images/icon-form.png" alt="Step 1" /><span><b>Form</b></span></li>
                                            <li><img src="./images/icon-complete-disabled.png" alt="Step 2" /><span
                                                className="text-gray">Complete</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <p className="theme-color text-20">School Record Request</p>
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body">
                                    <div className="card-content">
                                        <div className="table-summary d-flex flex-row flex-wrap">
                                            <div className="title">
                                                School Name:
                                            </div>
                                            <div className="value">
                                                {form_Data ? form_Data.SchoolName : ''}
                                            </div>
                                        </div>
                                        <div className="table-summary d-flex flex-row flex-wrap">
                                            <div className="title">
                                                Search Date (From):
                                            </div>
                                            <div className="value">
                                                {form_Data ? form_Data.SearchFromYear : ''}
                                            </div>
                                        </div>
                                        <div className="table-summary d-flex flex-row flex-wrap">
                                            <div className="title">
                                                Search Date (To):
                                            </div>
                                            <div className="value">
                                                {form_Data ? form_Data.SearchToYear : ''}
                                            </div>
                                        </div>
                                        <div className="table-summary d-flex flex-row flex-wrap">
                                            <div className="title">
                                                Remarks:
                                            </div>
                                            <div className="value d-flex flex-row flex-wrap">
                                                {form_Data ? form_Data.Remarks : ''}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="m-3">
                                <label className="theme-color">
                                    <input type="checkbox" onChange={toggleProceedtoForm} /> &nbsp;
                                    I certify that all information submitted is correct. Should the school’s records be transferred to NAS to carry out the search, an archival and administration fee of S${parseFloat(process.env.REACT_APP_ADMINFEE)} (inclusive of {parseInt(process.env.REACT_APP_GST)}% GST) will be levied.
                                </label>
                            </div>
                            <div >
                                <div className="text-center mt-3">
                                    {!alllowProceed && <button type="button" disabled={true} className="btn btn-primary me-2">Proceed to Checkout</button>}
                                    {alllowProceed && my_Libs && !my_Libs.isMylibsLogin && <button type="button" onClick={handleshowVdalidateOTPModal} className="btn btn-primary me-2">Proceed to Checkout</button>}
                                    {alllowProceed && my_Libs && my_Libs.isMylibsLogin && <button type="button" onClick={()=>dispatch(checkOutCurCart())} className="btn btn-primary me-2">Proceed to Checkout</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showVdalidateOTP} centered backdrop="static" size="md">
                <form onSubmit={(e) => validateOTP(e)}>
                    <Modal.Header>
                        <Modal.Title>Validate email to checkout</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {pages_state && !pages_state.isRequestedOtp && <div className="text-center">
                            <p>Proceed to send OTP to the following email address.</p>
                            <p className="theme-color text-18">{maskValue(form_Data ? form_Data.RequestorEmail : '')}</p>
                        </div>}
                        {pages_state && pages_state.isRequestedOtp && <div className='text-center'>
                            <p className="m-0">
                                An OTP has been sent to <span className="theme-color">{maskValue(form_Data ? form_Data.RequestorEmail : '')}</span>.
                            </p>
                            <label htmlFor="username" className="col-form-label">Please enter OTP to proceed.</label>
                            <div>
                                <input type="number" onWheel={(e) => e.target.blur()} className="form-control w-100" id="username" ref={setRef('otp')} autoComplete="off" placeholder="6-digit OTP" required />
                            </div>
                        </div>}
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center">
                        {pages_state && pages_state.isRequestedOtp && <div>
                            <button type="button" className="btn btn-secondary me-2" disabled={pages_state ? pages_state.disableBtn : false} onClick={() => resendOTP('email')}>Resend OTP {pages_state && pages_state.disableBtn ? '(' + pages_state.countdownNo + ')' : ''}</button>
                            <button type="submit" className="btn btn-primary">Confirm</button>
                        </div>}
                        {pages_state && !pages_state.isRequestedOtp && <div>
                            <button type="button" className="btn btn-secondary me-2" onClick={handleshowVdalidateOTPModal}>Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={sendOtp}>Send OTP</button>
                        </div>}

                    </Modal.Footer>
                </form>
            </Modal>
        </section>
    );
}





